import pkg from '../../package.json'
export const ENV = process.env.NODE_ENV as string // 当前开发环境
export const APP_NAME = process.env.VUE_APP_NAME as string // 当前应用名称
export const PACKAGE_NAME = pkg.xbase[APP_NAME].packageName // 当前模块名称（域名）
export const HEZI_API_URL = process.env.VUE_APP_HEZI_API_URL as string // 当前环境接口域名
export const isProd = ENV === 'production'
export const isSeparateAccount = APP_NAME === 'hezi-pro' // 独立账号
export const publicPath = isSeparateAccount ? '/pro': '/yc'
export const API = {
  'production': 'https://api-pan.xunlei.com',
  'development': 'https://api-alpha-drive.office.k8s.xunlei.cn',
  'heziProduction': HEZI_API_URL,
  'heziDevelopment': HEZI_API_URL,
}

export type TApiEnv = keyof typeof API
export let apiEnv: TApiEnv = 'production' // 配置当前api环境

export const setApiEnv = (env: keyof typeof API) => {
  if (!API[env]) throw new Error('apiEnv环境变量可选值为:production/development/heziProduction/heziDevelopment')
  apiEnv = env
}

console.log('process.env.NODE_ENV: ', ENV, 'api env: ', apiEnv, 'process.env.VUE_APP_NAME', APP_NAME, pkg.xbase[APP_NAME], HEZI_API_URL)

export const xlUserApis = {
  'development': isSeparateAccount ? ['https://30pjvxhw4311tsikmnm.xbase.cloud'] : ['https://dev-xluser-ssl.xunlei.com'],
  'production': isSeparateAccount ? ['https://30pjvxhw4311tsikmnm.xbase.cloud'] : ['https://xluser-ssl.xunlei.com', 'https://xluser2-ssl.xunlei.com', 'https://xluser3-ssl.xunlei.com'],
}

export const apiOrigins = xlUserApis[apiEnv]

export const oAuth2ClientOptions = {
  apiOrigins,
  ...pkg.xbase[APP_NAME],
}

export const apiOrigin = apiOrigins[0]

export const SSOconfig = Object.assign(
  {
    packageName: PACKAGE_NAME,
    apiOrigins,
    algVersion: '1',
    ...pkg.xbase[APP_NAME],
  },
  isSeparateAccount ? {
    scope: 'profile offline hezi sso user',
    provider: {
      apiOrigins: apiOrigins,
      clientId: pkg.xbase[APP_NAME].clientId,
      providerId: 'xunlei.com',
    },
  } : {
    scope: 'profile offline pan sso user',
    authorizePage: `https://i.xunlei.com/center/account/personal/oauth/?client_id=${pkg.xbase[APP_NAME].clientId}&ui_key=c`,
    signOutURI: `https://${PACKAGE_NAME}/yc/signout/?sso_sign_out=`,
  },
)

// 抱团接口： http://wiki.xunlei.cn/pages/viewpage.action?pageId=33336131
export const TeamSpeedApi = 'https://team-speed-cdn-vip.xunlei.com/team_speed'

export function getXBaseTokenInfo ():string {
  return localStorage.getItem(`credentials_${pkg.xbase[APP_NAME].clientId}`) as string
}
